import React from 'react'
import { Outlet } from 'react-router'

function MyCarPage() {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default MyCarPage